import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth22getGetScreenTruthSidecarsResponseSchema = jsonObject
export type tcpscreentruth22getGetScreenTruthSidecarsResponse = z.infer<typeof tcpscreentruth22getGetScreenTruthSidecarsResponseSchema>
export const tcpscreentruth22getGetScreenTruthWhoamiResponseSchema = jsonObject
export type tcpscreentruth22getGetScreenTruthWhoamiResponse = z.infer<typeof tcpscreentruth22getGetScreenTruthWhoamiResponseSchema>
